"use client";
import { useRouter } from "next/navigation";
import { useTransition } from "react";


export default function useRefresh() {
  const router = useRouter();
  const [isPending, startTransition] = useTransition();

  /**
   * Usage eg.
   *
   *   refresh(async () => {
   *     await service.method();
   *   });
   */
  const refresh = (cb?: () => Promise<void>) => {
    startTransition(async () => {
      if (cb) {
        await cb();
      }
      router.refresh();
    });
  };

  return { refresh, isRefreshing: isPending };
}
